import { render } from "./menuItemMobile.vue?vue&type=template&id=a6be7678&scoped=true"
import script from "./menuItemMobile.vue?vue&type=script&lang=js"
export * from "./menuItemMobile.vue?vue&type=script&lang=js"

import "./menuItemMobile.vue?vue&type=style&index=0&id=a6be7678&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6be7678"]])

export default __exports__